import React from "react";
import { List, ListItem, Checkbox, FormControlLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    checkboxPadding: {
        paddingLeft: ({ dir }) => (dir && dir === "rtl" ? "30px" : "")
    },
    label: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        padding: "0 20px"
    },
    disabled: {
        color: "#fff!important",
        opacity: "0.3"
    }
});

const listStyles = {
    list: {
        maxHeight: "300px",
        overflow: "auto"
    },
    item: {
        backgroundColor: "#41454a",
        marginBottom: ".5rem"
    }
};

const CollectionsList = ({
    collections = [],
    selectedIds = [],
    onToggle,
    canPin = true,
    memberships = [],
    dir = "ltr",
    listStyle = {}
}) => {
    const classes = useStyles({ dir });

    const sorted = [...collections].sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
    );

    const isChecked = (collection) => {
        // selectedIds may contain plain IDs or objects with an `id` field
        return selectedIds.some((entry) =>
            entry?.id !== undefined ? entry.id === collection.id : entry === collection.id
        );
    };

    return (
        <List style={{ ...listStyles.list, ...listStyle }} data-testid="orion-components-shared-components-collections-list-list">
            {sorted.map((collection) => (
                <ListItem key={collection.id} style={listStyles.item} disablePadding data-testid="orion-components-shared-components-collections-list-list-item">
                    <FormControlLabel
                        className="themedCheckBox"
                        control={
                            <Checkbox
                                className={classes.checkboxPadding}
                                disabled={!canPin && memberships.includes(collection.id)}
                                checked={isChecked(collection)}
                                onChange={(_, checked) => onToggle(collection, checked)} data-testid="orion-components-shared-components-collections-list-checkbox"
                            />
                        }
                        label={collection.name}
                        sx={{
                            height: "48px",
                            width: "100%",
                            margin: "0px",
                            padding: "7px"
                        }}
                        classes={{ label: classes.label }}
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default CollectionsList;